export const cropPixels = (rect, width, height) => {
  const left = Math.max(0, Math.min(99.99, Number(rect.x) || 0))
  const top = Math.max(0, Math.min(99.99, Number(rect.y) || 0))
  const x = Math.min(width - 1, Math.floor(width * left / 100))
  const y = Math.min(height - 1, Math.floor(height * top / 100))
  return { x, y, width: Math.max(1, Math.min(width - x, Math.round(width * Math.max(0.01, Number(rect.width) || 0.01) / 100))), height: Math.max(1, Math.min(height - y, Math.round(height * Math.max(0.01, Number(rect.height) || 0.01) / 100))) }
}

export const cropTransferProof = (file, rect) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const image = new Image()
  const fail = (error) => { URL.revokeObjectURL(url); reject(error) }
  image.onerror = () => fail(new Error('Gambar tidak dapat dibaca. Pilih ulang JPG/PNG/WEBP dari penyimpanan.'))
  image.onload = () => {
    try {
      const area = cropPixels(rect, image.naturalWidth, image.naturalHeight)
      const canvas = document.createElement('canvas')
      canvas.width = area.width
      canvas.height = area.height
      const context = canvas.getContext('2d')
      if (!context) throw new Error('Browser tidak mendukung crop. Gunakan file asli atau potong di galeri HP.')
      context.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, area.width, area.height)
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(url)
        if (!blob) { reject(new Error('Crop gagal. Gunakan file asli atau coba potongan yang lebih besar.')); return }
        resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '-crop.png', { type: 'image/png', lastModified: Date.now() }))
      }, 'image/png')
    } catch (error) { fail(error) }
  }
  image.src = url
})
